module.exports = __webpack_public_path__ + "img/logo_bottom.d9340015.png";